module.exports = __webpack_public_path__ + "img/Tadaa.b56d8ae1.jpg";